import React from 'react';
import ReactDOM from "react-dom";
import {Wrapper} from "@atttomyx/react-components";
import App from "./app";
import {branding, storage} from "@atttomyx/react-utils";
import {themes} from "@atttomyx/shared-constants";
import {NAMESPACE} from "./constants";
import "./themes/light.css";
import "./themes/dark.css";

storage.setNamespace(NAMESPACE);

ReactDOM.render(
    <Wrapper
        theme={themes.LIGHT}
        branding={branding.BRANDING_LIGHT}
    >
        {(onThemeChange, snackbar, dimensions) =>
            <App
                onThemeChange={onThemeChange}
                snackbar={snackbar}
                dimensions={dimensions}
            />}
    </Wrapper>,
    document.getElementById('root')
);
